import { PanelType } from '@fluentui/react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataIndicateur } from '../../data/DataIndicateur';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion';
import { EUICurrencyField } from '../EUI/EUICurrencyField';
import { EUINumericField } from '../EUI/EUINumericField';
import { EUIPanel } from '../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheCGReintegration extends Component {

    static defaultProps = {
        operation: {},
        /* --- */
        onDismiss: () => null,
        onSave: () => null
    };

    static defaultState = {
        indicateur: {},
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheCGReintegration.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des données en cours..."
        });

        const { operation } = this.props;
        const { compteur } = operation;

        DataIndicateur._chargementIndicateur(compteur).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const indicateur = responseFetch.reponseAPIobjet;
                const state = { indicateur };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onDelayedChange = (propertyName) => (event, newValue) => {
        if (!newValue && newValue !== 0) newValue = null;
        this.setState(
            prev => ({ indicateur: { ...prev.indicateur, [propertyName]: newValue } }),
            this._onVerificationFormulaire
        );
    };

    _onOpen = () => {
        const { operation } = this.props;
        this.setState({ ...FicheCGReintegration.defaultState });
        if (!!operation)
            this._chargementDonnees();
    };

    _onSave = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement en cours..."
        });

        const { onSave } = this.props;
        const { indicateur } = this.state;

        DataIndicateur._onEnregistrementIndicateur(indicateur, "reintegration").then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onSave);
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onVerificationFormulaire = () => {
        const { compteur } = this.props.operation;
        const { indicateur } = this.state;
        Immocom.fiche()._validationFormulaire(this, "CGReintegration", indicateur, !!compteur ? "Modification" : "Création");
    };

    render = () => {

        const { isOpen, onDismiss, operation } = this.props;
        const { indicateur, onActiveBoutonEnregistrer } = this.state;
        const { reintegrationCA, reintegrationNb, reintegrationSurface } = indicateur;
        const { nomOperation } = operation;

        return <EUIPanel
            headerText={`Réintégration pour l'opération ${nomOperation}`}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._onSave}
            type={PanelType.medium}
        >

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <ComboBoxRegion
                disabled
                selectedKey={this.state.indicateur.idRegion}
            />

            <ComboBoxAgence
                disabled
                idRegion={this.state.indicateur.idRegion}
                selectedKey={this.state.indicateur.idAgence}
            />

            <ComboBoxOperation
                disabled
                idAgence={this.state.indicateur.idAgence}
                idRegion={this.state.indicateur.idRegion}
                perimetre="eiffage"
                selectedKey={this.state.indicateur.idOperation}
            />

            <EUINumericField
                label="Nb logements"
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onDelayedChange("reintegrationNb")}
                value={reintegrationNb}
            />

            <EUINumericField
                label="Surface habitable / utile"
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onDelayedChange("reintegrationSurface")}
                suffix="m²"
                value={reintegrationSurface}
            />

            <EUICurrencyField
                label="CA HT"
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onDelayedChange("reintegrationCA")}
                value={reintegrationCA}
            />

        </EUIPanel>;

    };

};